const moment = require('moment-timezone');
const axios = require('axios');
import util from '@/util/util'

async function salesByMember(startDate, endDate, page, searchType, keyword) {
    const token = `${localStorage.getItem('token')}`
    const uid = `${localStorage.getItem('shopsUid')}`
    const shopObjectId = `${localStorage.getItem('shopObjectId')}`
    const startAt = moment(String(startDate)).format('YYYY-MM-DD')
    const endAt = moment(String(endDate)).format('YYYY-MM-DD')
    const headers = {
        Authorization: token,
        shopObjectId: util.sanitizeShopObjectId(shopObjectId),
    }
    const params = {
        shopObjectId: shopObjectId,
        startAt: startAt,
        endAt: endAt,
        page: page
    }

    if (searchType && keyword && keyword.trim() !== '') {
        params.searchVal = keyword
        params.searchAttr = searchType
    }

    try {
        const res = await axios({
            baseURL: process.env.VUE_APP_SERVICE_URL,
            url: '/api/v1.0/' + uid + '/receipt/member/channel',
            headers: headers,
            params: params,
            method: 'GET',
        })

        return res.data
    } catch (error) {
        // Handle errors
        console.log(error)
        return null
    }
}

async function exportPhoneReport(startDate, endDate, locale, searchType, keyword) {
    const token = `${localStorage.getItem('token')}`
    const uid = `${localStorage.getItem('shopsUid')}`
    const shopObjectId = `${localStorage.getItem('shopObjectId')}`
    const startAt = moment(String(startDate)).format('YYYY-MM-DD')
    const endAt = moment(String(endDate)).format('YYYY-MM-DD')
    const headers = {
        Authorization: token,
        shopObjectId: util.sanitizeShopObjectId(shopObjectId),
    };
    const params = {
        shopObjectId: shopObjectId,
        startAt: startAt,
        endAt: endAt,
        lang: locale
    };
    if (searchType && keyword && keyword.trim() !== '') {
        params.searchVal = keyword
        params.searchAttr = searchType
    }
    try {
        const res = await axios({
            baseURL: process.env.VUE_APP_SERVICE_URL,
            url: '/api/v1.0/' + uid + '/receipt/member/channel/excel',
            params: params,
            headers: headers,
            method: 'GET',
            responseType: 'blob', // important for excel export
        });
        return res.data;
    } catch (error) {
        console.log(error);
        return null;
    }
}

export { salesByMember, exportPhoneReport }
